import { render, staticRenderFns } from "./agregardigitalizador.vue?vue&type=template&id=392f0fac"
import script from "./agregardigitalizador.vue?vue&type=script&lang=js"
export * from "./agregardigitalizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports